import { z } from "zod";

// Body of POST /api/invites/redeem. Matches the inline `Body` schema already
// in apps/api/src/routes/invites/redeem.ts (Phase 3 early port). Lifted into
// the shared package so apps/web can validate the redeem form before submit.
export const inviteRedeemInputSchema = z.object({
  token: z.string().min(1),
  password: z.string().min(8).optional(),
});

export type InviteRedeemInput = z.infer<typeof inviteRedeemInputSchema>;

// Body of POST /api/settings/invites/internal and POST
// /api/admin/users/team/invite. `roleId` is optional for backward-compat with
// the legacy Settings invite form; when present (User Manager flow) the invite
// carries the chosen fine-grained role and finalize_invite_redemption applies
// it. When absent, the 0022 sync trigger defaults the new internal user to the
// 'admin' role.
export const internalInviteCreateSchema = z.object({
  email: z.string().trim().email().max(320),
  roleId: z.string().uuid().optional(),
});

export type InternalInviteCreateInput = z.infer<typeof internalInviteCreateSchema>;

// Body of POST /api/admin/users/:userId/role — change an internal teammate's
// fine-grained role.
export const teamRoleChangeSchema = z.object({
  roleId: z.string().uuid(),
});

export type TeamRoleChangeInput = z.infer<typeof teamRoleChangeSchema>;

// Body of POST /api/admin/users/:userId/active — suspend (false) or restore
// (true) an account's ability to sign in.
export const userActiveSchema = z.object({
  active: z.boolean(),
});

export type UserActiveInput = z.infer<typeof userActiveSchema>;
